import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UnderMaintenanceService } from '..';

@Injectable({
  providedIn: 'root'
})
export class UnderMaintenanceGuard  {

  constructor(private underMaintenanceService: UnderMaintenanceService) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return !this.underMaintenanceService.active;
  }
  
}
